import React from 'react';

import { PromotionSectionCard } from './PromotionSectionCard';
import { SearchableDropdown } from '../../component/SearchableDropdown';
import { TextInput } from '../../component/TextInput';
import { TextInputMultiLine } from '../../component/TextInputMultiLine';
import { Option } from '../../pages/types';

export function AutoRenewSection({
  autoRenewIntoPaidSubscription,
  setAutoRenewIntoPaidSubscription,

  eligibleCountrySelected,

  paidProductOptions,
  selectedPaidProductOption,
  setSelectedPaidProductOption,

  paidQuantity,
  setPaidQuantity,

  disclaimer,
  setDisclaimer,
}: {
  autoRenewIntoPaidSubscription: boolean;
  setAutoRenewIntoPaidSubscription: (v: boolean) => void;

  eligibleCountrySelected: boolean;

  paidProductOptions: Option[];
  selectedPaidProductOption: Option | null;
  setSelectedPaidProductOption: (o: Option | null) => void;

  paidQuantity: string;
  setPaidQuantity: (v: string) => void;

  disclaimer: string;
  setDisclaimer: (v: string) => void;
}) {
  return (
    <PromotionSectionCard>
      <div className="w-full my-2">
        <h2>Auto-renew into a paid subscription product?</h2>

        <div className="flex flex-col space-y-1 mt-2">
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="radio"
              name="autoRenewPaidSubscription"
              value="no"
              className="accent-black"
              checked={!autoRenewIntoPaidSubscription}
              onChange={() => setAutoRenewIntoPaidSubscription(false)}
            />
            <span>No</span>
          </label>
          <p className="text-xs text-gray-500 font-normal ml-6">
            Free product will be added to trial order, but it will not renew as a paid subscription
            product
          </p>

          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="radio"
              name="autoRenewPaidSubscription"
              value="yes"
              className="accent-black"
              checked={autoRenewIntoPaidSubscription}
              onChange={() => setAutoRenewIntoPaidSubscription(true)}
            />
            <span>Yes</span>
          </label>
          <p className="text-xs text-gray-500 font-normal ml-6">
            Free product will be added to trial order and it will renew as a paid subscription
            product on the customer’s next subscription order
          </p>
        </div>
      </div>

      {autoRenewIntoPaidSubscription ? (
        <>
          <div className="w-full my-4">
            <h2>Paid subscription product</h2>
            <div className="flex justify-between space-x-4">
              <div className="w-3/4">
                <SearchableDropdown
                  placeholder={
                    !eligibleCountrySelected
                      ? 'Select eligible country first'
                      : 'Select paid subscription product(s)'
                  }
                  options={paidProductOptions}
                  value={selectedPaidProductOption ?? null}
                  onChange={(newSelection: any) =>
                    setSelectedPaidProductOption(newSelection ?? null)
                  }
                  isDisabled={!eligibleCountrySelected}
                />
              </div>
              <div className="w-1/4">
                <TextInput
                  placeholder="None"
                  value={paidQuantity}
                  setTextChange={setPaidQuantity}
                />
              </div>
            </div>
          </div>

          <div className="w-full my-4">
            <h2>
              Disclaimer <span className="text-xs">(Optional)</span>
            </h2>
            <p className="text-xs text-gray-500 font-normal mb-2">
              Customer-facing disclaimer to be displayed on funnel checkout page
            </p>

            <div className="w-full mb-2">
              <TextInputMultiLine
                rows={3}
                placeholder="Optional disclaimer text"
                value={disclaimer}
                setTextChange={setDisclaimer}
              />
            </div>
          </div>
        </>
      ) : null}
    </PromotionSectionCard>
  );
}
